import { c as _c } from "react-compiler-runtime";
import { useCallback, useLayoutEffect } from 'react';
import { useRef } from 'react';

/**
 * https://github.com/reactjs/rfcs/blob/useevent/text/0000-useevent.md
 *
 * The callback returned from this hook MUST be used ONLY in a useEffect
 * and ONLY in the same component that it was created in
 */
export function useEventCallback(handler) {
  "use memo";

  const $ = _c(3);
  const handlerRef = useRef(undefined);
  let t0;
  if ($[0] !== handler) {
    t0 = () => {
      handlerRef.current = handler;
    };
    $[0] = handler;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useLayoutEffect(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (...t2) => {
      const args = t2;
      const fn = handlerRef.current;
      return fn === null || fn === void 0 ? void 0 : fn(...args);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}